// Keeps the Diagonal Card's clip-path cuts — both the content card's right
// edge and the photo's left edge — at exactly the same angle as the accent
// tab's `transform: skewX(--dc-cut-angle)` (see _style-variations.scss) no
// matter how tall the content column grows. A clip-path polygon's %
// coordinates can't reference the box's own height directly — CSS has no
// self-referencing container query — so this measures the content column's
// rendered height with a ResizeObserver and writes it to --dc-card-height-px
// on the OUTER grid container (not the content column itself), so the media
// column — a sibling, not a descendant, of the content column — inherits it
// too for its own clip-path.
export function initDiagonalCardCut(): void {
  const contentBoxes = document.querySelectorAll<HTMLElement>(
    ".is-style-diagonal-card.wp-block-media-text > .wp-block-media-text__content",
  );
  if (!contentBoxes.length) return;

  const observer = new ResizeObserver((entries) => {
    for (const entry of entries) {
      const content = entry.target as HTMLElement;
      const card = content.parentElement;
      card?.style.setProperty("--dc-card-height-px", `${entry.contentRect.height}px`);
    }
  });

  contentBoxes.forEach((content) => observer.observe(content));
}
